import list from './list';
import marks, { InteractiveObjectLink } from './marks';
import types from './types';
import { PreventUpscalePTImage } from './types/image';
import blocks from './blocks';
import { type PortableTextComponents } from '@portabletext/react';

const ptComponents: PortableTextComponents = {
	marks: marks,
	list: list,
	types: types,
	block: blocks,
};

export const editorialPtComponents = {
	...ptComponents,
	types: {
		...ptComponents.types,
		image: PreventUpscalePTImage,
	},
};

export const interactiveObjectLinksPtComponents = {
	...ptComponents,
	marks: {
		...ptComponents.marks,
		interactiveObjectLink: InteractiveObjectLink,
	},
};

export default ptComponents;
